import { Injectable } from '@angular/core';
import { BurialsService } from './burials.service';
import { RestApiService } from './rest-api.service';
import { RestApiEndpoints } from '../enums/rest-api-endpoints';

declare function makeToast(message: string): void;

@Injectable({
    providedIn: 'root'
})
export class PDFService {

    constructor(private burialsService: BurialsService, private restApiService: RestApiService) { }

    private payloadEntity(type: string, value: any): any {
        return {
            Type: type,
            Value: value
        };
    };

    createDocumentOfType(documentType: any, documentPayload: any, completionHandler: any) {
        if (!documentType || !documentPayload) { return; }

        var printContractOptions: any = {};

        printContractOptions['drucken.NurDaten'] = this.payloadEntity('bool', false);
        printContractOptions['drucken.DatenInklFormular'] = this.payloadEntity('bool', true);

        // Füge die Unterschriften hinzu, falls vorhanden
        if (documentPayload.bestatterSignature) {
            printContractOptions['bestatter_signature'] = this.payloadEntity('text', documentPayload.bestatterSignature);
        } else {
            printContractOptions['bestatter_signature'] = this.payloadEntity('text', '');
        }
        
        if (documentPayload.angehoerigerSignature) {
            printContractOptions['angehoeriger_signature'] = this.payloadEntity('text', documentPayload.angehoerigerSignature);
        } else {
            printContractOptions['angehoeriger_signature'] = this.payloadEntity('text', '');
        }

        var undertakerID = '';
        var undertakerPhone = '';
        var undertakerFax = '';
        var undertakerAddress1 = '';
        var undertakerAddress2 = '';
        var undertakerStreet = '';
        var undertakerZip = '';
        var undertakerCity = '';

        const bestatter = localStorage.getItem('bestatter');
        if (bestatter) {
            var tmpBestatter = JSON.parse(bestatter);
            if (tmpBestatter && tmpBestatter.hasOwnProperty('id')) {
                undertakerID = tmpBestatter.id;
            }
            if (tmpBestatter && tmpBestatter.hasOwnProperty('telefon')) {
                undertakerPhone = tmpBestatter.telefon;
            }
            if (tmpBestatter && tmpBestatter.hasOwnProperty('telefax')) {
                undertakerFax = tmpBestatter.telefax;
            }
            if (tmpBestatter && tmpBestatter.hasOwnProperty('adresse1')) {
                undertakerAddress1 = tmpBestatter.adresse1;
            }
            if (tmpBestatter && tmpBestatter.hasOwnProperty('adresse2')) {
                undertakerAddress2 = tmpBestatter.adresse2;
            }
            if (tmpBestatter && tmpBestatter.hasOwnProperty('strasse')) {
                undertakerStreet = tmpBestatter.strasse;
            }
            if (tmpBestatter && tmpBestatter.hasOwnProperty('plz')) {
                undertakerZip = tmpBestatter.plz;
            }
            if (tmpBestatter && tmpBestatter.hasOwnProperty('ort')) {
                undertakerCity = tmpBestatter.ort;
            }
        }

        printContractOptions['best_standort.kundennummer'] = this.payloadEntity('text', undertakerID);
        printContractOptions['best_standort.email'] = this.payloadEntity('text', '');
        printContractOptions['best_standort.telefon'] = this.payloadEntity('text', undertakerPhone);
        printContractOptions['best_standort.telefax'] = this.payloadEntity('text', undertakerFax);
        printContractOptions['best_standort.adresse1'] = this.payloadEntity('text', undertakerAddress1);
        printContractOptions['best_standort.adresse2'] = this.payloadEntity('text', undertakerAddress2);
        printContractOptions['best_standort.strasse'] = this.payloadEntity('text', undertakerStreet);
        printContractOptions['best_standort.plz'] = this.payloadEntity('text', undertakerZip);
        printContractOptions['best_standort.ort'] = this.payloadEntity('text', undertakerCity);

        var v_name = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputName')) {
            v_name = documentPayload.burialData.inputName;
        } else if (documentPayload.hasOwnProperty('v_lastname')) {
            v_name = documentPayload.v_lastname;
        }
        printContractOptions.v_name = this.payloadEntity('text', v_name);

        var v_vorname = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputLastName')) {
            v_vorname = documentPayload.burialData.inputLastName;
        } else if (documentPayload.hasOwnProperty('v_frontname')) {
            v_vorname = documentPayload.v_frontname;
        }
        printContractOptions.v_vorname = this.payloadEntity('text', v_vorname);

        var v_geburtsname = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputBirthName')) {
            v_geburtsname = documentPayload.burialData.inputBirthName;
        } else if (documentPayload.hasOwnProperty('v_birthname')) {
            v_geburtsname = documentPayload.v_birthname;
        }
        printContractOptions.v_geburtsname = this.payloadEntity('text', v_geburtsname);

        var v_geschlecht = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputGender')) {
            v_geschlecht = documentPayload.burialData.inputGender;
        } else if (documentPayload.hasOwnProperty('v_gender')) {
            v_geschlecht = documentPayload.v_gender;
        }
        printContractOptions.v_geschlecht = this.payloadEntity('text', v_geschlecht);

        var v_plz = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputZip')) {
            v_plz = documentPayload.burialData.inputZip;
        } else if (documentPayload.hasOwnProperty('v_zip')) {
            v_plz = documentPayload.v_zip;
        }
        printContractOptions.v_plz = this.payloadEntity('text', v_plz);

        var v_ort = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputCity')) {
            v_ort = documentPayload.burialData.inputCity;
        } else if (documentPayload.hasOwnProperty('v_city')) {
            v_ort = documentPayload.v_city;
        }
        printContractOptions.v_ort = this.payloadEntity('text', v_ort);

        var v_strasse = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputStreet')) {
            v_strasse = documentPayload.burialData.inputStreet;
        } else if (documentPayload.hasOwnProperty('v_street')) {
            v_strasse = documentPayload.v_street;
        }
        printContractOptions.v_strasse = this.payloadEntity('text', v_strasse);

        var v_geburtstag = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputBirthDate')) {
            v_geburtstag = documentPayload.burialData.inputBirthDate;
        } else if (documentPayload.hasOwnProperty('v_birthday')) {
            v_geburtstag = this.burialsService.readableDateFromString(documentPayload.v_birthday);
        }
        printContractOptions.v_geburtstag = this.payloadEntity('text', v_geburtstag);

        var v_geburtsort = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputBirthPlace')) {
            v_geburtsort = documentPayload.burialData.inputBirthPlace;
        } else if (documentPayload.hasOwnProperty('v_birthplace')) {
            v_geburtsort = documentPayload.v_birthplace;
        }
        printContractOptions.v_geburtsort = this.payloadEntity('text', v_geburtsort);

        var v_todestag = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputDeathDate')) {
            v_todestag = documentPayload.burialData.inputDeathDate;
        } else if (documentPayload.hasOwnProperty('v_deathday')) {
            v_todestag = this.burialsService.readableDateFromString(documentPayload.v_deathday);
        }
        printContractOptions.v_todestag = this.payloadEntity('text', v_todestag);

        var v_todeszeit = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputDeathTime')) {
            v_todeszeit = documentPayload.burialData.inputDeathTime;
        } else if (documentPayload.hasOwnProperty('v_deathtime')) {
            v_todeszeit = this.burialsService.readableTimeFromString(documentPayload.v_deathtime);
        }
        printContractOptions.v_todeszeit = this.payloadEntity('text', v_todeszeit);

        var v_todesort = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputDeathPlace')) {
            v_todesort = documentPayload.burialData.inputDeathPlace;
        } else if (documentPayload.hasOwnProperty('v_deathplace')) {
            v_todesort = documentPayload.v_deathplace;
        }
        printContractOptions.v_todesort = this.payloadEntity('text', v_todesort);

        var beisetzungs_ort_klartext = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputBurialPlace')) {
            beisetzungs_ort_klartext = documentPayload.burialData.inputBurialPlace;
        } else if (documentPayload.hasOwnProperty('beisetzungs_ort_klartext')) {
            beisetzungs_ort_klartext = documentPayload.beisetzungs_ort_klartext;
        }
        printContractOptions.beisetzungs_ort_klartext = this.payloadEntity('text', beisetzungs_ort_klartext);

        var standesamt = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('registryOffice')) {
            standesamt = documentPayload.burialData.registryOffice;
        } else if (documentPayload.hasOwnProperty('v_registryoffice')) {
            standesamt = documentPayload.v_registryoffice;
        }
        printContractOptions.standesamt = this.payloadEntity('text', standesamt);

        var sterbeurkunde_nr = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('registryOfficeNumber')) {
            sterbeurkunde_nr = documentPayload.burialData.registryOfficeNumber;
        } else if (documentPayload.hasOwnProperty('v_registryofficenumber')) {
            sterbeurkunde_nr = documentPayload.v_registryofficenumber;
        }
        printContractOptions.sterbeurkunde_nr = this.payloadEntity('text', sterbeurkunde_nr);

        var gesundheitsamt_klartext = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('healthOffice')) {
            gesundheitsamt_klartext = documentPayload.burialData.healthOffice;
        } else if (documentPayload.hasOwnProperty('gesundheitsamt_klartext')) {
            gesundheitsamt_klartext = documentPayload.gesundheitsamt_klartext;
        }
        printContractOptions.gesundheitsamt_klartext = this.payloadEntity('text', gesundheitsamt_klartext);

        var urnenversand_rueckfuehrung_id = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputReturnType')) {
            urnenversand_rueckfuehrung_id = documentPayload.burialData.inputReturnType;
        } else if (documentPayload.hasOwnProperty('d_urndeliverytype')) {
            urnenversand_rueckfuehrung_id = documentPayload.d_urndeliverytype;
        }
        printContractOptions.urnenversand_rueckfuehrung_id = this.payloadEntity('text', urnenversand_rueckfuehrung_id);

        var versand_name1 = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputReturnLastName')) {
            versand_name1 = documentPayload.burialData.inputReturnLastName;
        } else if (documentPayload.hasOwnProperty('d_nameone')) {
            versand_name1 = documentPayload.d_nameone;
        }
        printContractOptions.versand_name1 = this.payloadEntity('text', versand_name1);

        var versand_name2 = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputReturnName')) {
            versand_name2 = documentPayload.burialData.inputReturnName;
        } else if (documentPayload.hasOwnProperty('d_nametwo')) {
            versand_name2 = documentPayload.d_nametwo;
        }
        printContractOptions.versand_name2 = this.payloadEntity('text', versand_name2);

        var versand_strasse = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputReturnStreet')) {
            versand_strasse = documentPayload.burialData.inputReturnStreet;
        } else if (documentPayload.hasOwnProperty('d_street')) {
            versand_strasse = documentPayload.d_street;
        }
        printContractOptions.versand_strasse = this.payloadEntity('text', versand_strasse);

        var versand_plz = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputReturnZip')) {
            versand_plz = documentPayload.burialData.inputReturnZip;
        } else if (documentPayload.hasOwnProperty('d_zip')) {
            versand_plz = documentPayload.d_zip;
        }
        printContractOptions.versand_plz = this.payloadEntity('text', versand_plz);

        var versand_ort = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputReturnCity')) {
            versand_ort = documentPayload.burialData.inputReturnCity;
        } else if (documentPayload.hasOwnProperty('d_city')) {
            versand_ort = documentPayload.d_city;
        }
        printContractOptions.versand_ort = this.payloadEntity('text', versand_ort);

        var termin_wunsch = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputReturnDate')) {
            termin_wunsch = documentPayload.burialData.inputReturnDate;
        } else if (documentPayload.hasOwnProperty('d_urndeliverydate')) {
            termin_wunsch = this.burialsService.readableDateFromString(documentPayload.d_urndeliverydate);
        }
        printContractOptions.termin_wunsch = this.payloadEntity('text', termin_wunsch);

        var termin_wunsch_zeit = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputReturnTime')) {
            termin_wunsch_zeit = documentPayload.burialData.inputReturnTime;
        } else if (documentPayload.hasOwnProperty('d_urndeliverytime')) {
            termin_wunsch_zeit = this.burialsService.readableTimeFromString(documentPayload.d_urndeliverytime);
        }
        printContractOptions.termin_wunsch_zeit = this.payloadEntity('text', termin_wunsch_zeit);

        var a_anrede = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputClientSalutation')) {
            a_anrede = documentPayload.burialData.inputClientSalutation;
        } else if (documentPayload.hasOwnProperty('a_salutation')) {
            a_anrede = documentPayload.a_salutation;
        }
        printContractOptions.a_anrede = this.payloadEntity('text', a_anrede);

        var a_name = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputClientLastName')) {
            a_name = documentPayload.burialData.inputClientLastName;
        } else if (documentPayload.hasOwnProperty('a_lastname')) {
            a_name = documentPayload.a_lastname;
        }
        printContractOptions.a_name = this.payloadEntity('text', a_name);

        var a_vorname = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputClientName')) {
            a_vorname = documentPayload.burialData.inputClientName;
        } else if (documentPayload.hasOwnProperty('a_name')) {
            a_vorname = documentPayload.a_name;
        }
        printContractOptions.a_vorname = this.payloadEntity('text', a_vorname);

        var a_strasse = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputClientStreet')) {
            a_strasse = documentPayload.burialData.inputClientStreet;
        } else if (documentPayload.hasOwnProperty('a_street')) {
            a_strasse = documentPayload.a_street;
        }
        printContractOptions.a_strasse = this.payloadEntity('text', a_strasse);

        var a_plz = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputClientZip')) {
            a_plz = documentPayload.burialData.inputClientZip;
        } else if (documentPayload.hasOwnProperty('a_zip')) {
            a_plz = documentPayload.a_zip;
        }
        printContractOptions.a_plz = this.payloadEntity('text', a_plz);

        var a_ort = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputClientCity')) {
            a_ort = documentPayload.burialData.inputClientCity;
        } else if (documentPayload.hasOwnProperty('a_city')) {
            a_ort = documentPayload.a_city;
        }
        printContractOptions.a_ort = this.payloadEntity('text', a_ort);

        var ueberurne_id = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputUrnType')) {
            ueberurne_id = documentPayload.burialData.inputUrnType;
        } else if (documentPayload.hasOwnProperty('urntype')) {
            ueberurne_id = documentPayload.urntype;
        }
        printContractOptions.ueberurne_id = this.payloadEntity('text', ueberurne_id);

        var ueberurne_name = '';
        if (ueberurne_id && ueberurne_id.length > 0) {
            if (ueberurne_id == '17') {
                ueberurne_name = 'Friedwaldurne';
            } else if (ueberurne_id == '18') {
                ueberurne_name = 'Aschebeutel';
            } else if (ueberurne_id == '19') {
                ueberurne_name = 'Bio Urne';
            } else if (ueberurne_id == '20') {
                ueberurne_name = 'Stahlkapsel';
            } else if (ueberurne_id == '21') {
                ueberurne_name = 'Kohleurne mit Schnur';
            } else if (ueberurne_id == '22') {
                ueberurne_name = 'Kohleurne ohne Schnur';
            } else if (ueberurne_id == '23') {
                ueberurne_name = 'Guttenberg Urne';
            } else if (ueberurne_id == '24') {
                ueberurne_name = 'Eigene Urne';
            }
        }
        printContractOptions.ueberurne_name = this.payloadEntity('text', ueberurne_name);

        var ueberurne_vorhanden = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputUrnStyle')) {
            ueberurne_vorhanden = documentPayload.burialData.inputUrnStyle;
        } else if (documentPayload.hasOwnProperty('urnstyle')) {
            ueberurne_vorhanden = documentPayload.urnstyle;
        }
        printContractOptions.ueberurne_vorhanden = this.payloadEntity('text', ueberurne_vorhanden);

        var auftragsmemo = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputBurialInfo')) {
            auftragsmemo = documentPayload.burialData.inputBurialInfo;
        } else if (documentPayload.hasOwnProperty('contractinfo')) {
            auftragsmemo = documentPayload.contractinfo;
        }
        printContractOptions.auftragsmemo = this.payloadEntity('text', auftragsmemo);

        var kommune_art = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('anonymousBurialContract')) {
            kommune_art = documentPayload.burialDates.anonymousBurialContract;
        } else if (documentPayload.hasOwnProperty('s_anonymousBurialSiteBeisetzungArt_ID')) {
            kommune_art = documentPayload.s_anonymousBurialSiteBeisetzungArt_ID;
        }
        printContractOptions.kommune_art = this.payloadEntity('text', kommune_art);

        var kommune_type = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('anonymousBurialType')) {
            kommune_type = documentPayload.burialDates.anonymousBurialType;
        } else if (documentPayload.hasOwnProperty('s_anonymousBurialSiteBeisetzungTyp_ID')) {
            kommune_type = documentPayload.s_anonymousBurialSiteBeisetzungTyp_ID;
        }
        printContractOptions.kommune_type = this.payloadEntity('text', kommune_type);

        var kommune_id = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('anonymousBurialSite')) {
            kommune_id = documentPayload.burialDates.anonymousBurialSite;
        } else if (documentPayload.hasOwnProperty('s_anonymousburialsuite')) {
            kommune_id = documentPayload.s_anonymousburialsuite;
        }
        // Mapping Portal-IDs zu KremaSoft kommunen_ids für korrekte Übertragung
        const portalToKremaSoftKommuneId: { [key: string]: string } = {
            '50': '5749',  // Kräuterhochbeet → RTK-Kräutergarten
            '51': '6225'   // Waldlichtung Rheinhöhen-Ruhewald Braubach → DFG-Waldlichtung
        };
        const kommune_id_for_kremasoft = portalToKremaSoftKommuneId[kommune_id] || kommune_id;
        printContractOptions.kommune_id = this.payloadEntity('text', kommune_id_for_kremasoft);

        if (kommune_id && kommune_id != '15' && kommune_id != '48') {
            documentType = documentType.replace('RTK', 'DFG');
        }

        var grabart_id = '';
        printContractOptions.grabart_id = this.payloadEntity('text', grabart_id);

        var beisetzung_datum = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('anonymousBurialSiteDateWish')) {
            beisetzung_datum = documentPayload.burialDates.anonymousBurialSiteDateWish;
        } else if (documentPayload.hasOwnProperty('s_anonymousBurialSiteDateWish')) {
            beisetzung_datum = documentPayload.s_anonymousBurialSiteDateWish;
        }
        printContractOptions.beisetzung_datum = this.payloadEntity('text', beisetzung_datum);

        var beisetzung_uhrzeit = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('anonymousBurialSiteTimeWish')) {
            beisetzung_uhrzeit = documentPayload.burialDates.anonymousBurialSiteTimeWish;
        } else if (documentPayload.hasOwnProperty('s_anonymousBurialSiteTimeWish')) {
            beisetzung_uhrzeit = documentPayload.s_anonymousBurialSiteTimeWish;
        }
        printContractOptions.beisetzung_uhrzeit = this.payloadEntity('text', beisetzung_uhrzeit);

        var beisetzung_info = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('anonymousBurialSiteInfo')) {
            beisetzung_info = documentPayload.burialDates.anonymousBurialSiteInfo;
        } else if (documentPayload.hasOwnProperty('s_anonymousBurialSiteBeisetzung_Info')) {
            beisetzung_info = documentPayload.s_anonymousBurialSiteBeisetzung_Info;
        }
        printContractOptions.beisetzung_info = this.payloadEntity('text', beisetzung_info);

        var sargabholung_datum_von = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('driveServiceDateWishFrom')) {
            sargabholung_datum_von = documentPayload.burialDates.driveServiceDateWishFrom;
        } else if (documentPayload.hasOwnProperty('s_driveserviceDateWish')) {
            sargabholung_datum_von = documentPayload.s_driveserviceDateWish;
        }
        printContractOptions.sargabholung_datum_von = this.payloadEntity('text', sargabholung_datum_von);

        var sargabholung_uhrzeit_von = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('driveServiceTimeWishFrom')) {
            sargabholung_uhrzeit_von = documentPayload.burialDates.driveServiceTimeWishFrom;
        } else if (documentPayload.hasOwnProperty('s_driveserviceTimeWish')) {
            sargabholung_uhrzeit_von = documentPayload.s_driveserviceTimeWish;
        }
        printContractOptions.sargabholung_uhrzeit_von = this.payloadEntity('text', sargabholung_uhrzeit_von);

        var sargabholung_datum_bis = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('driveServiceDateWishTo')) {
            sargabholung_datum_bis = documentPayload.burialDates.driveServiceDateWishTo;
        }
        printContractOptions.sargabholung_datum_bis = this.payloadEntity('text', sargabholung_datum_bis);

        var sargabholung_uhrzeit_bis = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('driveServiceTimeWishTo')) {
            sargabholung_uhrzeit_bis = documentPayload.burialDates.driveServiceTimeWishTo;
        }
        printContractOptions.sargabholung_uhrzeit_bis = this.payloadEntity('text', sargabholung_uhrzeit_bis);

        var sargabholung_info = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('driveServiceInfo')) {
            sargabholung_info = documentPayload.burialDates.driveServiceInfo;
        } else if (documentPayload.hasOwnProperty('s_driveserviceInfo')) {
            sargabholung_info = documentPayload.s_driveserviceInfo;
        }
        printContractOptions.sargabholung_info = this.payloadEntity('text', sargabholung_info);

        var verabschiedung_id = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('adoptionType')) {
            verabschiedung_id = documentPayload.burialDates.adoptionType;
        } else if (documentPayload.hasOwnProperty('adoptiontype')) {
            verabschiedung_id = documentPayload.adoptiontype;
        }
        printContractOptions.verabschiedung_id = this.payloadEntity('text', verabschiedung_id);

        var verabschiedung_ea_datum = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('adoptionDateWish')) {
            verabschiedung_ea_datum = documentPayload.burialDates.adoptionDateWish;
        } else if (documentPayload.hasOwnProperty('adoptiondate')) {
            verabschiedung_ea_datum = documentPayload.adoptiondate;
        }
        printContractOptions.verabschiedung_ea_datum = this.payloadEntity('text', verabschiedung_ea_datum);

        var verabschiedung_ea_uhrzeit = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('adoptionTimeWish')) {
            verabschiedung_ea_uhrzeit = documentPayload.burialDates.adoptionTimeWish;
        } else if (documentPayload.hasOwnProperty('adoptiontime')) {
            verabschiedung_ea_uhrzeit = documentPayload.adoptiontime;
        }
        printContractOptions.verabschiedung_ea_uhrzeit = this.payloadEntity('text', verabschiedung_ea_uhrzeit);

        var verabschiedung_info = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('adoptionTypeInfo')) {
            verabschiedung_info = documentPayload.burialDates.adoptionTypeInfo;
        } else if (documentPayload.hasOwnProperty('adoptioninfo')) {
            verabschiedung_info = documentPayload.adoptioninfo;
        }
        printContractOptions.verabschiedung_info = this.payloadEntity('text', verabschiedung_info);

        var namensschild = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('inputNametagSwitch')) {
            namensschild = documentPayload.burialDates.inputNametagSwitch;
        } else if (documentPayload.hasOwnProperty('s_anonymousBurialSiteBeisetzung_Namensschild')) {
            namensschild = documentPayload.s_anonymousBurialSiteBeisetzung_Namensschild;
        }
        printContractOptions.namensschild = this.payloadEntity('text', namensschild);

        var nutzungsrecht_neuerstellen = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('inputTreeNumberSwitch')) {
            nutzungsrecht_neuerstellen = documentPayload.burialDates.inputTreeNumberSwitch;
        } else if (documentPayload.hasOwnProperty('s_anonymousBurialSiteBeisetzung_Tree_New')) {
            nutzungsrecht_neuerstellen = documentPayload.burialDates.s_anonymousBurialSiteBeisetzung_Tree_New;
        }
        printContractOptions.nutzungsrecht_neuerstellen = this.payloadEntity('text', nutzungsrecht_neuerstellen);

        var nutzsrecht_baum_nr = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('inputTreeNumber')) {
            nutzsrecht_baum_nr = documentPayload.burialDates.inputTreeNumber;
        } else if (documentPayload.hasOwnProperty('s_anonymousBurialSiteBeisetzung_Tree_Nr')) {
            nutzsrecht_baum_nr = documentPayload.s_anonymousBurialSiteBeisetzung_Tree_Nr;
        }
        if (nutzungsrecht_neuerstellen && nutzungsrecht_neuerstellen == '1') {
            nutzsrecht_baum_nr = '';
        }
        printContractOptions.nutzsrecht_baum_nr = this.payloadEntity('text', nutzsrecht_baum_nr);

        var vorsorge_nummer = '';
        if (documentPayload.hasOwnProperty('burialDates') && documentPayload.burialDates.hasOwnProperty('inputProvisionNumber')) {
            vorsorge_nummer = documentPayload.burialDates.inputProvisionNumber;
        } else if (documentPayload.hasOwnProperty('s_anonymousBurialSiteBeisetzung_Provisioning_Nr')) {
            vorsorge_nummer = documentPayload.s_anonymousBurialSiteBeisetzung_Provisioning_Nr;
        }
        printContractOptions.vorsorge_nummer = this.payloadEntity('text', vorsorge_nummer);

        var urnentraeger = '';
        printContractOptions.urnentraeger = this.payloadEntity('text', urnentraeger);

        var beisetzung_gemeinschaftsgrab = '';
        printContractOptions.beisetzung_gemeinschaftsgrab = this.payloadEntity('text', beisetzung_gemeinschaftsgrab);

        var verabschiedung = '';
        if (verabschiedung_id && verabschiedung_id.length > 0) {
            if (verabschiedung_id == '1') {
                verabschiedung = 'Einäscherung mit Angehörigen mit Halle';
            } else if (verabschiedung_id == '2') {
                verabschiedung = 'Einäscherung ohne Angehörige';
            } else if (verabschiedung_id == '3') {
                verabschiedung = 'Sargverabschiedung in der Trauerhalle';
            } else if (verabschiedung_id == '4') {
                verabschiedung = 'Sargverabschiedung in der Trauerhalle mit anschließender Direkteinäscherung';
            } else if (verabschiedung_id == '5') {
                verabschiedung = 'Einäscherung mit Angehörigen ohne Halle';
            } else if (verabschiedung_id == '7') {
                verabschiedung = 'Bestatter 1 Stunde vor Einäscherung anrufen';
            } else if (verabschiedung_id == '13') {
                verabschiedung = 'Aufbahrung (Sarg offen)';
            } else if (verabschiedung_id == '14') {
                verabschiedung = 'Aufbahrung (Sarg geschlossen)';
            } else if (verabschiedung_id == '15') {
                verabschiedung = 'Trauerfeier mit Urne';
            }
        }
        printContractOptions['service.verabschiedung'] = this.payloadEntity('text', verabschiedung);

        var beisetzungsort = '';
        if (kommune_id && kommune_id.length > 0) {
            beisetzungsort = this.burialsService.readableBurialPlaceFromID(kommune_id);
        }
        printContractOptions['service.beisetzungsort'] = this.payloadEntity('text', beisetzungsort);

        var beisetzungsart = '';
        if (kommune_type && kommune_type.length > 0) {
            if (kommune_type == '6') {
                beisetzungsart = 'Verabschiedung an der Urne';
            } else if (kommune_type == '1') {
                beisetzungsart = 'Beisetzung mit Angehörigen direkt am Grab';
            } else if (kommune_type == '2') {
                beisetzungsart = 'Beisetzung mit Angehörigen ohne Halle / Waldkapelle';
            } else if (kommune_type == '3') {
                beisetzungsart = 'Beisetzung mit Angehörigen mit Halle / Waldkapelle';
            } else if (kommune_type == '4') {
                beisetzungsart = 'Beisetzung ohne Angehörige';
            }
        }
        printContractOptions['service.beisetzungsart'] = this.payloadEntity('text', beisetzungsart);

        var beisetzungsvertrag = '';
        if (kommune_art && kommune_art.length > 0) {
            if (kommune_art == '7') {
                beisetzungsvertrag = 'Einzelgrab';
            } else if (kommune_art == '5') {
                beisetzungsvertrag = 'Partnergrab';
            } else if (kommune_art == '42') {
                beisetzungsvertrag = 'Einzelgrab';
            } else if (kommune_art == '37') {
                beisetzungsvertrag = 'Partnergrab';
            } else if (kommune_art == '9') {
                beisetzungsvertrag = 'Einzelbaum, 20 Jahre';
            } else if (kommune_art == '10') {
                beisetzungsvertrag = 'Einzelbaum, 50 Jahre';
            } else if (kommune_art == '11') {
                beisetzungsvertrag = 'Familienbaum, 20 Jahre';
            } else if (kommune_art == '12') {
                beisetzungsvertrag = 'Familienbaum, 50 Jahre';
            } else if (kommune_art == '13') {
                beisetzungsvertrag = 'Gemeinschaftsbaum, 20 Jahre';
            } else if (kommune_art == '14') {
                beisetzungsvertrag = 'Gemeinschaftsbaum, 50 Jahre';
            } else if (kommune_art == '15') {
                beisetzungsvertrag = 'Bestatterbaum, 20 Jahre';
            } else if (kommune_art == '16') {
                beisetzungsvertrag = 'Bestatterbaum, 50 Jahre';
            } else if (kommune_art == '31') {
                beisetzungsvertrag = 'Freundschaftsgarb';
            } else if (kommune_art == '30') {
                beisetzungsvertrag = 'Familiengrab';
            } else if (kommune_art == '19') {
                beisetzungsvertrag = 'Einstellung 1 Jahr';
            } else if (kommune_art == '1') {
                beisetzungsvertrag = 'Einzelgrab';
            } else if (kommune_art == '2') {
                beisetzungsvertrag = 'Partnergrab';
            } else if (kommune_art == '3') {
                beisetzungsvertrag = 'Themengrab';
            } else if (kommune_art == '50') {
                beisetzungsvertrag = 'Einzelgrab';
            } else if (kommune_art == '51') {
                beisetzungsvertrag = 'Partnergrab';
            } else if (kommune_art == '52') {
                beisetzungsvertrag = 'Einzelgrab';
            } else if (kommune_art == '53') {
                beisetzungsvertrag = 'Familiengrab';
            }
        }
        printContractOptions['service.beisetzungsvertrag'] = this.payloadEntity('text', beisetzungsvertrag);

        var grabart = '';
        printContractOptions['service.grabart'] = this.payloadEntity('text', grabart);

        var urnenversand_rueckfuehrung_name = '';
        if (documentPayload.hasOwnProperty('burialData') && documentPayload.burialData.hasOwnProperty('inputReturnType')) {
            urnenversand_rueckfuehrung_name = documentPayload.burialData.inputReturnType;
        } else if (documentPayload.hasOwnProperty('d_urndeliverytype')) {
            urnenversand_rueckfuehrung_name = documentPayload.d_urndeliverytype;
        }
        if (urnenversand_rueckfuehrung_name && urnenversand_rueckfuehrung_name == '1') {
            urnenversand_rueckfuehrung_name = 'Urnenversand';
        } else if (urnenversand_rueckfuehrung_name && urnenversand_rueckfuehrung_name == '2') {
            urnenversand_rueckfuehrung_name = 'Abholung durch den Bestatter';
        } else if (urnenversand_rueckfuehrung_name && urnenversand_rueckfuehrung_name == '3') {
            urnenversand_rueckfuehrung_name = 'Rückführung mit dem nächsten Fahrdienst';
        }
        printContractOptions.urnenversand_rueckfuehrung_name = this.payloadEntity('text', urnenversand_rueckfuehrung_name);

        var frueheste_ea = '';
        if (v_todestag && v_todeszeit) {
            var tmp_frueheste_ea = this.burialsService.burialDateFromDeathDate(v_todestag, v_todeszeit);
            frueheste_ea = tmp_frueheste_ea.burialDate + ' ' + tmp_frueheste_ea.burialTime;
        }
        printContractOptions.frueheste_ea = this.payloadEntity('text', frueheste_ea);

        //////
        var dok_antrag_pdf = '';
        if (documentPayload.hasOwnProperty('burialDocs') && documentPayload.burialDocs.hasOwnProperty('burialorderData')) {
            dok_antrag_pdf = documentPayload.burialDocs.burialorderData;
        } else if (documentPayload.hasOwnProperty('i_burialorderData')) {
            dok_antrag_pdf = documentPayload.i_burialorderData;
        }
        printContractOptions.dok_antrag_pdf = this.payloadEntity('text', dok_antrag_pdf);

        var dok_amtsarzt_ls_durchgefuehrt_pdf = '';
        if (documentPayload.hasOwnProperty('burialDocs') && documentPayload.burialDocs.hasOwnProperty('corpsepassData')) {
            dok_amtsarzt_ls_durchgefuehrt_pdf = documentPayload.burialDocs.corpsepassData;
        } else if (documentPayload.hasOwnProperty('i_corpsepassData')) {
            dok_amtsarzt_ls_durchgefuehrt_pdf = documentPayload.i_corpsepassData;
        }
        printContractOptions.dok_amtsarzt_ls_durchgefuehrt_pdf = this.payloadEntity('text', dok_amtsarzt_ls_durchgefuehrt_pdf);

        var dok_amtsarzt_ls_bereits_extern_durchgefuehrt_pdf = '';
        if (documentPayload.hasOwnProperty('burialDocs') && documentPayload.burialDocs.hasOwnProperty('corpseshowData')) {
            dok_amtsarzt_ls_bereits_extern_durchgefuehrt_pdf = documentPayload.burialDocs.corpseshowData;
        } else if (documentPayload.hasOwnProperty('i_corpseshowData')) {
            dok_amtsarzt_ls_bereits_extern_durchgefuehrt_pdf = documentPayload.i_corpseshowData;
        }
        printContractOptions.dok_amtsarzt_ls_bereits_extern_durchgefuehrt_pdf = this.payloadEntity('text', dok_amtsarzt_ls_bereits_extern_durchgefuehrt_pdf);

        var dok_freigabe_staatsanwalt_pdf = '';
        if (documentPayload.hasOwnProperty('burialDocs') && documentPayload.burialDocs.hasOwnProperty('lawyerreleaseData')) {
            dok_freigabe_staatsanwalt_pdf = documentPayload.burialDocs.lawyerreleaseData;
        } else if (documentPayload.hasOwnProperty('i_lawyerreleaseData')) {
            dok_freigabe_staatsanwalt_pdf = documentPayload.i_lawyerreleaseData;
        }
        printContractOptions.dok_freigabe_staatsanwalt_pdf = this.payloadEntity('text', dok_freigabe_staatsanwalt_pdf);

        var dok_todesbescheinigung_pdf = '';
        if (documentPayload.hasOwnProperty('burialDocs') && documentPayload.burialDocs.hasOwnProperty('deathapprovalData')) {
            dok_todesbescheinigung_pdf = documentPayload.burialDocs.deathapprovalData;
        } else if (documentPayload.hasOwnProperty('i_deathapprovalData')) {
            dok_todesbescheinigung_pdf = documentPayload.i_deathapprovalData;
        }
        printContractOptions.dok_todesbescheinigung_pdf = this.payloadEntity('text', dok_todesbescheinigung_pdf);

        var dok_todesbescheinigung_vertraulich_pdf = '';
        if (documentPayload.hasOwnProperty('burialDocs') && documentPayload.burialDocs.hasOwnProperty('deathapprovalsecretData')) {
            dok_todesbescheinigung_vertraulich_pdf = documentPayload.burialDocs.deathapprovalsecretData;
        } else if (documentPayload.hasOwnProperty('i_deathapprovalsecretData')) {
            dok_todesbescheinigung_vertraulich_pdf = documentPayload.i_deathapprovalsecretData;
        }
        printContractOptions.dok_todesbescheinigung_vertraulich_pdf = this.payloadEntity('text', dok_todesbescheinigung_vertraulich_pdf);

        var dok_besch_sterbefall_pdf = '';
        if (documentPayload.hasOwnProperty('burialDocs') && documentPayload.burialDocs.hasOwnProperty('deathcertificateData')) {
            dok_besch_sterbefall_pdf = documentPayload.burialDocs.deathcertificateData;
        } else if (documentPayload.hasOwnProperty('i_deathcertificateData')) {
            dok_besch_sterbefall_pdf = documentPayload.i_deathcertificateData;
        }
        printContractOptions.dok_besch_sterbefall_pdf = this.payloadEntity('text', dok_besch_sterbefall_pdf);

        var dok_urnenanforderung_pdf = '';
        if (documentPayload.hasOwnProperty('burialDocs') && documentPayload.burialDocs.hasOwnProperty('urnrequestData')) {
            dok_urnenanforderung_pdf = documentPayload.burialDocs.urnrequestData;
        } else if (documentPayload.hasOwnProperty('i_urnrequestData')) {
            dok_urnenanforderung_pdf = documentPayload.i_urnrequestData;
        }
        printContractOptions.dok_urnenanforderung_pdf = this.payloadEntity('text', dok_urnenanforderung_pdf);

        var dok_we_zur_fb_pdf = '';
        if (documentPayload.hasOwnProperty('burialDocs') && documentPayload.burialDocs.hasOwnProperty('intentdeclerationData')) {
            dok_we_zur_fb_pdf = documentPayload.burialDocs.intentdeclerationData;
        } else if (documentPayload.hasOwnProperty('i_intentdeclerationData')) {
            dok_we_zur_fb_pdf = documentPayload.i_intentdeclerationData;
        }
        printContractOptions.dok_we_zur_fb_pdf = this.payloadEntity('text', dok_we_zur_fb_pdf);

        var dok_stuff = '';
        if (documentPayload.hasOwnProperty('burialDocs') && documentPayload.burialDocs.hasOwnProperty('stuffData')) {
            dok_stuff = documentPayload.burialDocs.stuffData;
        } else if (documentPayload.hasOwnProperty('i_stuffData')) {
            dok_stuff = documentPayload.i_stuffData;
        }
        printContractOptions.dok_stuff = this.payloadEntity('text', dok_stuff);
        //////

        printContractOptions.status_aenderungen_senden = this.payloadEntity('text', '');

        var printContractOptionsPostBody: any = {};
        printContractOptionsPostBody.crd = documentType;
        printContractOptionsPostBody.payload = printContractOptions;

        this.restApiService.sendAsyncRequestToEndpoint(RestApiEndpoints.pdfCreate, printContractOptionsPostBody, (success, response) => {
            if (!success) {
                makeToast('Verbindungsfehler, bitte erneut versuchen');
                if (completionHandler) { completionHandler(null); }
                return;
            }

            if (response.success) {
                if (completionHandler) { completionHandler(response.payload); }
            } else {
                makeToast('Fehler beim erstellen der PDF, bitte erneut versuchen');
                if (completionHandler) { completionHandler(null); }
            }
        });
    }

}
